import React from 'react';

interface OdxRadioButtonProps {
    name: string;
    value: string;
    label: string;
    checked: boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    className?: string;
    description?: string;
    id?: string
}

/**
 * Radio button component. Is used to display a radio button.
 * @param name name of radio button group
 * @param value is the value of the radio button
 * @param label is the label to display next to the radio button
 * @param checked is the state of the radio button
 * @param onChange is the function to call when the radio button state changes
 * @param className is the additional classes to apply to the div around the radio button
 * @param description is the description to display below the radio button
 * @constructor
 */
const OdxRadioButton: React.FC<OdxRadioButtonProps> = ({
                                                           name,
                                                           value,
                                                           label,
                                                           checked,
                                                           onChange,
                                                           className,
                                                           description,
                                                           id
                                                       }) => {
    return (
        <div
            className={`odx-radio-button odx-radio-button--with-label ${checked ? 'is-active' : ''} ${className ? className : ''}`}>
            <label className="odx-radio-button__label">
                <input
                    type="radio"
                    className="odx-radio-button__input"
                    name={name}
                    value={value}
                    checked={checked}
                    onChange={onChange}
                    aria-checked={checked}
                />
                <div className="odx-radio-button__indicator"></div>
                <div id={"OdxRadioButton_Text_" + id} className="odx-radio-button__content">
                    {label}
                    {description && <div className="odx-radio-button__subtitle">{description}</div>}
                </div>
            </label>
        </div>
    );
};

export default OdxRadioButton;